import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';

import { Input } from 'antd';

import { Form, StyledModal } from 'common/components';

import MemberManagementEditForm from './MemberManagementEditForm';

import { apiHandler } from 'utils/api';
import * as memberManagementService from 'services/memberMaintenance';
import { useDispatchReloadPage } from 'hooks/useReloadPage';
import { useGlobalModal } from 'hooks';

import Messages from 'i18n/messages/maintenance';

const MemberManagementEditModal = (props) => {
  const [form] = Form.useForm();
  const intl = useIntl();
  const reloadPage = useDispatchReloadPage();

  const [loading, setLoading] = useState(false);

  const { checkModalVisible, closeModal, MODAL_NAMES } = useGlobalModal();
  const modalName = MODAL_NAMES.MEMBER_MAINTAIN.CREATE;
  const visible = checkModalVisible(modalName);

  const onCancelHandler = () => {
    !loading && closeModal(modalName);
  };

  const onOkHandler = () => {
    form.validateFields().then((values) => {
      callApiEditMember(values);
    });
  };

  const initForm = () => {
    form.resetFields();
    setLoading(false);
  };

  const callApiEditMember = (values) => {
    if (!values) return;

    setLoading(true);

    const {
      memberName,
      accessChat,
      accessDigitalAssets,
      accessFTP,
      accessFolders,
      accessGDSN,
      accessInterops,
      accessMember,
      accessProducts,
      accessReporting,
      accessSyndication,
      accessWorkflow,
    } = values;

    const params = {
      memberName: memberName?.trim(),
      canAccessProducts: accessProducts,
      canAccessMember: accessMember,
      canAccessDigitalAssets: accessDigitalAssets,
      canAccessFolders: accessFolders,
      canAccessSyndication: accessSyndication,
      canAccessGdsn: accessGDSN,
      canAccessFtp: accessFTP,
      canAccessInterops: accessInterops,
      canAccessChat: accessChat,
      canAccessReporting: accessReporting,
      canAccessWorkflow: accessWorkflow,
    };

    const successMessage = intl.formatMessage(Messages.createMemberSuccess);
    const errorMessage = intl.formatMessage(Messages.createMemberError);

    apiHandler({
      service: memberManagementService.createMemberManagement,
      params,
      successMessage,
      errorMessage,
      successCallback: editSuccessCallback,
      onFinally: hideLoading,
    });
  };

  const editSuccessCallback = () => {
    reloadPage();
    closeModal(modalName);
  };

  const hideLoading = () => {
    setLoading(false);
  };

  useEffect(() => {
    if (visible) initForm();
  }, [visible]);

  //* render
  const extraFields = (
    <Form.Item
      name='memberName'
      label={intl.formatMessage(Messages.memberName)}
      rules={[
        {
          required: true,
          message: intl.formatMessage(Messages.memberNameRequired),
        },
        {
          whitespace: true,
          message: intl.formatMessage(Messages.memberNameInvalid),
        },
      ]}
    >
      <Input />
    </Form.Item>
  );

  const okBtnProp = { loading };
  const cancelBtnProp = { disabled: loading };

  return (
    <StyledModal
      visible={visible}
      closeable={false}
      onCancel={onCancelHandler}
      onOk={onOkHandler}
      okButtonProps={okBtnProp}
      cancelButtonProps={cancelBtnProp}
      okText={intl.formatMessage(Messages.editMemberModalOkBtn)}
      title={intl.formatMessage(Messages.createMemberModalTitle)}
    >
      <MemberManagementEditForm form={form} extraFields={extraFields} />
    </StyledModal>
  );
};

export default MemberManagementEditModal;
